import Wrapper from './styles';
import React from 'react';
import { Title, Content, Button } from './styles';
import { useDispatch, useSelector } from 'react-redux';
import { removeFilter, setFilter } from 'redux/general/actions';
import dataJson from 'shared/data';

const FilterGroup = ({title, data, keyName, autoGenerate, exclude}) => {
  const dispatch = useDispatch();
  const filters  = useSelector((reduxState) => reduxState.general.filters);
  const cv = filters[keyName] ? filters[keyName] : '*';

  if(autoGenerate && !data){
    data = [];
    const types = {};
    
    dataJson.map((_d) => {
      const type = _d[keyName];
      if(!types[type] && (exclude !== type)){
        data.push({
          name: type,
          value: type
        });
        types[type] = 1;
      }
    })

    data.push({
      name: 'Todos',
      value: '*'
    });

  }


  const renderButtons = data.map((_d) => {

    const onClick = () => {
      const isActive = cv === _d.value || cv.includes(_d.value);
      if(!isActive){
        dispatch(setFilter(keyName, _d.value));
      }else{
        dispatch(removeFilter(keyName, _d.value));
      }
    }
    return <Button
              active={cv === _d.value || cv.includes(_d.value)} 
              key={_d.value}
              onClick={onClick}
            >
              {_d.name}
            </Button>
  })


  return(
    <Wrapper>
      <Title>{title}</Title>
      <Content>
        {renderButtons}
      </Content>
    </Wrapper>
  )
}

export default FilterGroup;